export const getCookieValueCSR = (key) => {
  if (!document) return null;

  const match = document.cookie.match(new RegExp('(^|; )' + key + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export const setCookieCSR = ({ key, value, days }) => {
  if (!document) return;

  let cookieStr = `${(key)}=${(value)}; path=/`;

  if (typeof days === 'number' && !isNaN(days)) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStr += `; expires=${date.toUTCString()}`;
  }

  document.cookie = cookieStr;
};
